"use strict";import{tag as l}from"../custom-tag.js";export function subscribeIcon({height:s=16,width:e=16,hidden:r=!1,title:t="Subscribe"}={}){return l`
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width=${e}
      height=${s}
      fill="currentColor"
      viewBox="0 0 24 24"
      aria-hidden="${r?"true":"false"}"
      role="img"
      aria-label="${t}"
    >
      <mask
        id="subscribe_svg__mask0_6875_6236"
        width="20"
        height="17"
        x="2"
        y="4"
        maskUnits="userSpaceOnUse"
        style="mask-type:alpha"
      >
        <path
          fill="currentColor"
          d="m2 18.706 7.146-6.796L2 5.143zm10-5.823L21.407 4H2.595zm-1.942.039L2.59 20h19.092l-7.736-7.084-1.948 1.845zM22 18.457V5.143l-7.137 6.758z"
        />
      </mask>
      <g mask="url(#subscribe_svg__mask0_6875_6236)">
        <path fill="currentColor" d="M24 0H0v24h24z" />
      </g>
    </svg>
  `}
//# sourceMappingURL=subscribe.js.map
